<script setup lang="ts">
import type { Role } from '@cockpit/shared';
import { computed, onBeforeUnmount, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { visibleTabs } from '../navigation';
import { useBadgesStore } from '../stores/badges';
import { useNouveautesStore } from '../stores/nouveautes';

const props = defineProps<{ role: Role }>();
const route = useRoute();
const tabs = computed(() => visibleTabs(props.role));
const badges = useBadgesStore();
/** Lot BA : point vert sur les onglets dont l'écran a des nouveautés, jusqu'à ce qu'on les ouvre. */
const nouveautes = useNouveautesStore();
onMounted(() => badges.start());
onBeforeUnmount(() => badges.stop());
</script>

<template>
  <nav class="tabs" role="tablist" aria-label="Vues">
    <RouterLink
      v-for="tab in tabs"
      :id="`tab-${tab.name}`"
      :key="tab.name"
      :to="tab.path"
      role="tab"
      :aria-selected="(route.meta.tab ?? route.name) === tab.name ? 'true' : 'false'"
      :data-tab="tab.name"
      :data-late="tab.name === 'afaire' && badges.late > 0 ? badges.late : undefined"
      :title="tab.name === 'afaire' && badges.late > 0 ? `${badges.late} en retard` : undefined"
      :data-news="nouveautes.newsTabs.includes(tab.name) ? '' : undefined"
      :aria-describedby="nouveautes.newsTabs.includes(tab.name) ? 'nv-tab-news' : undefined"
    >
      {{ tab.label
      }}<span v-if="nouveautes.newsTabs.includes(tab.name)" class="nv-tab-dot" aria-hidden="true"></span>
    </RouterLink>
  </nav>
  <!-- Lot BA : description du point vert pour les lecteurs d'écran (hors de la liste d'onglets). -->
  <span v-if="nouveautes.newsTabs.length" id="nv-tab-news" class="sr-only">Nouveautés sur cet écran</span>
</template>
